<template>
	<div class="submenu_left">
		<!-- <el-col :span="12"> -->
			<el-menu
				default-active="2"
				class="el-menu-vertical-demo"
				@open="handleOpen" 
				@close="handleClose" 
				background-color="#01061e" 
				text-color="#fff" 
				active-text-color="#ffe700">
				<el-submenu index="1">
					<template slot="title">
						<i class="el-icon-location-information"></i>
						<span>地区范围</span>
						<el-button class="leftadd_icon" type="primary" icon="el-icon-plus" @click="sendMsgmap"></el-button>
					</template>
					<el-menu-item index="1-1">东区</el-menu-item>
					<el-menu-item index="1-2">西区</el-menu-item>
					<el-menu-item index="1-3">南区</el-menu-item>
					<el-menu-item index="1-4">北区</el-menu-item>
				</el-submenu>
				<el-submenu index="2">
					<template slot="title">
						<i class="el-icon-leida"></i>
						<span>雷达</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="2-1"><i class="leida"></i>R01</el-menu-item>
						<el-menu-item index="2-2"><i class="leida"></i>R02</el-menu-item>
						<el-menu-item index="2-3"><i class="leida"></i>R03</el-menu-item>
						<el-menu-item index="2-4"><i class="leida"></i>R04</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="3">
					<template slot="title">
						<i class="el-icon-sunny"></i>
						<span>天气环境</span>
						<el-button class="leftadd_icon" type="primary" icon="el-icon-plus" @click="sendMsgenvr"></el-button>
					</template>
					<el-menu-item-group>
						<el-menu-item index="3-1">大晴</el-menu-item>
						<el-menu-item index="3-2">小雨</el-menu-item>
						<el-menu-item index="3-3">多云</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="4">
					<template slot="title">
						<i class="el-icon-heavy-rain"></i>
						<span>雨团设置</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="4-1"><i class="yutuan"></i>雨团1</el-menu-item>
						<el-menu-item index="4-2"><i class="yutuan"></i>雨团2</el-menu-item>
						<el-menu-item index="4-2"><i class="yutuan"></i>雨团3</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		<!-- </el-col> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			sendMsgmap(){
				this.$emit('func',true)
			},
			sendMsgenvr(){
				this.$emit('func2',true)
			},
		}
	}
</script>

<style>
	.submenu_left{overflow-y: auto;height: 100%}
	.submenu_left .el-menu{border-right: solid 0px #e6e6e6;}
	.submenu_left .el-menu .el-submenu { margin-bottom: 12px;}
	.submenu_left .el-menu .el-submenu .el-submenu__title{border-left: 2px solid #17fff3; border-right: 2px solid #17fff3;background-color: #0a164f!important;text-align: left;}
	.submenu_left .el-menu .el-submenu .el-submenu__title span{color: #ffffff;font-weight: bold;}
	.submenu_left .el-menu .el-submenu .el-submenu__title i{color: #19e8fc;}
	.submenu_left .el-menu .el-submenu .el-menu-item{padding-left: 0!important;padding-right: 0!important; text-align: center; width: 100%;min-width: max-content;
		border-bottom: 2px solid #223f8e;
		border-image: -webkit-linear-gradient(to right,rgba(34, 63, 142, 0.23), rgb(34, 63, 142),rgba(34, 63, 142, 0.54)) 20 20;
		border-image: -moz-linear-gradient(to right,rgba(34, 63, 142, 0.23), rgb(34, 63, 142),rgba(34, 63, 142, 0.54)) 20 20;
		border-image: -o-linear-gradient(to right,rgba(34, 63, 142, 0.23), rgb(34, 63, 142),rgba(34, 63, 142, 0.54)) 20 20;
		border-image: linear-gradient(to right,rgba(34, 63, 142, 0.23), rgb(34, 63, 142),rgba(34, 63, 142, 0.54)) 20 20;
		background: #01061e;
		background: -webkit-linear-gradient(#01061e, #0a164f);
		background: -o-linear-gradient(#01061e, #0a164f);
		background: -moz-linear-gradient(#01061e, #0a164f);
		background: linear-gradient(#01061e, #0a164f);
	}
	.submenu_left .el-menu .el-submenu .el-menu-item i{
		background-size: 18px;
		background-position: left;
		background-repeat: no-repeat;
		width: 18px;
		height: 18px;
		display: inline-block;
		margin-right: 10px;
	}
	.submenu_left .el-menu .el-submenu .el-menu-item .yutuan{background-image: url(../assets/left_icon7.png);}
	.submenu_left .el-menu .el-submenu .el-menu-item .leida{background-image: url(../assets/left_icon5.png);}
	.el-icon-leida{background-image: url(../assets/left_icon2.png);height: 18px; background-size: 18px 18px; background-repeat: no-repeat; background-position: 4px center;}
	
	.submenu_left .el-menu .el-submenu .el-submenu__title .leftadd_icon{padding: 0;margin-left: 20px; background-color: transparent;text-align: center;}
	.submenu_left .el-menu .el-submenu .el-submenu__title .leftadd_icon i{font-size: 12px;padding: 2px 0px;margin: 0;}
	
</style>
